<template>
  <div class="hero">
    <img class="hero__image" src="@images/heroImage.png" alt="image">
    <div class="container">
      <div class="hero__wrapper">
        <div class="hero__title">
          <h2>{{ t('home.hero.title') }}</h2>
        </div>
        <p class="hero__subtitle">{{ t('home.hero.subtitle') }}</p>
<!--        <form @submit="redirect" class="hero__input">-->
<!--          <input-->
<!--              type="text"-->
<!--              :placeholder="t('fields.search')"-->
<!--              v-model="searchInput"-->
<!--          >-->
<!--&lt;!&ndash;          <img src="@icons/searchIcon.svg" alt="search">&ndash;&gt;-->
<!--          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <g id="vuesax/broken/search-normal">-->
<!--              <g id="search-normal">-->
<!--                <path id="Vector"-->
<!--                    d="M11.9791 2.08325C17.4478 2.08325 21.8749 6.51034 21.8749 11.9791C21.8749 17.4478 17.4478 21.8749 11.9791 21.8749C6.51034 21.8749 2.08325 17.4478 2.08325 11.9791C2.08325 8.12492 4.28117 4.79159 7.49992 3.15617"-->
<!--                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                <path id="Vector_2" d="M22.9166 22.9166L20.8333 20.8333" stroke="currentColor" stroke-width="2"-->
<!--                    stroke-linecap="round" stroke-linejoin="round"/>-->
<!--              </g>-->
<!--            </g>-->
<!--          </svg>-->
<!--        </form>-->
        <div class="hero__auth" v-if="!user">
          <router-link :to="translations.i18nRoute({ name: 'login' })" class="hero__auth-login">{{ t('buttons.login') }}</router-link>
          <router-link :to="translations.i18nRoute({ name: 'register' })" class="hero__auth-reg">
            {{ t('buttons.createAcc') }}
            <img src="@icons/registerArrow.svg" alt="register">
          </router-link>
        </div>
        <div class="hero__auth" v-else>
          <router-link
              v-for="category of categories"
              :key="category.node.uuid"
              :to="translations.i18nRoute({ name: 'store', params: { category: category.node.slug } })"
          >
            {{ category.node.name }}
          </router-link>
        </div>
<!--        <div class="hero__icons">-->
<!--          <div class="hero__icons-item">-->
<!--            <img src="@icons/htmlIcon.png" alt="html">-->
<!--          </div>-->
<!--          <div class="hero__icons-item">-->
<!--            <img src="@icons/cssIcon.png" alt="css">-->
<!--          </div>-->
<!--          <div class="hero__icons-item">-->
<!--            <img src="@icons/jsIcon.png" alt="js">-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, onMounted, ref, watch} from "vue";
import {useAuthStore} from "@/stores/auth.js";
import translations from "@/core/helpers/translations.js";
import {useRouter} from "vue-router";
import {Categories} from "@/core/api/categories.js";

const {t, locale} = useI18n()
const authStore = useAuthStore()
const router = useRouter()

const user = computed(() => {
  return authStore.user
})

const searchInput = ref('')

const redirect = () => {
  router.push({
    name: 'search',
    query: {
      name: searchInput.value
    }}
  )
}

const categories = ref([])

const getCategories = async () => {
  const res = await Categories.getCategories()
  categories.value = res.data.categories.edges
}

watch(locale, async () => {
  await getCategories()
})

onMounted(async () => {
  await getCategories()
})
</script>

<style lang="scss" scoped>
.hero {
  padding-top: 112px;
  background-image: url(@images/heroBg.png);
  background-repeat: no-repeat;
  background-position: top right;
  -webkit-background-size: contain;
  background-size: contain;
  position: relative;

  &__image {
    position: absolute;
    bottom: -250px;
    left: 0;
    width: 350px;
  }

  &__wrapper {
    position: relative;
    z-index: 1;
    width: fit-content;
    padding-block: 100px 250px;
  }

  &__title {
    width: fit-content;
    border-radius: 17px;
    background-color: $white;
    box-shadow: 0 4px 13.5px 0 rgba(0, 0, 0, 0.15);
    padding: 7px 15px;

    & h2 {
      background: linear-gradient(90deg, #FF85FD 0.5%, #7D045A 44.83%, #3D2B44 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: Syne, sans-serif;
      color: #222;
      font-size: 56px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }

  &__subtitle {
    margin-block: 60px 80px;
    width: 500px;

    text-align: justify;
    color: #696969;
    font-size: 22px;
    font-weight: 500;
  }

  &__input {
    width: 100%;
    position: relative;
    margin-block: 70px 40px;

    & input {
      width: 100%;
      border-radius: 8px;
      border: 1px solid #AB3294;
      background: #FFF;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.15);
      padding: 13px 20px;

      color: #696969;
      font-size: 16px;
      font-weight: 500;
    }

    & svg {
      position: absolute;
      z-index: 1;
      right: 17px;
      top: 50%;
      transform: translateY(-50%);
      color: #AB3294;
    }
  }

  &__auth {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 15px;

    color: $white;
    font-size: 20px;
    font-weight: 500;

    & a {
      background-color: #5B194F;
      padding: 9px 20px;
      border-radius: 12px 30px 30px 12px;

      &:last-child {
        box-shadow: 0 0 11.6px 0 rgba(0, 0, 0, 0.20);
        background-color: $white;

        color: #2B3044;
      }
    }
  }

  &__icons {
    margin-top: 60px;
    display: flex;
    align-items: center;
    gap: 32px;

    &-item {
      padding: 5px 12px;
      border-radius: 7px;
      background: $white;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    }
  }
}

@media (max-width: 750px) {
  .hero {
    background-image: none;

    &__wrapper {
      padding-top: 50px;
    }

    &__title {
      text-align: center;
      font-size: 32px;
    }

    &__subtitle {
      text-align: center;
      font-size: 16px;
      width: 100%;
    }
  }
}

@media (max-width: 500px) {
  .hero {
    &__wrapper {
      padding-bottom: 50px;
    }

    &__auth {
      flex-direction: column;
      margin-inline: auto;
    }

    &__image {
      display: none;
    }
  }
}
</style>